<div
  class="rounded-input bg-input-background box-border flex w-full flex-col text-base"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div
    class="rounded-input relative w-full bg-inherit"
    [id]="id() | appendTestId: 'anchor'">
    <input
      [attr.data-bwignore]="ignoreBitwardenAutofill ? 'true' : null"
      [attr.data-testid]="id() | appendTestId: 'input'"
      autocomplete="off"
      (keydown.backspace)="ngControl.control!.setValue(undefined)"
      [formControl]="ngControl.control! | toFormControl"
      (click)="toggleList()"
      [id]="id()"
      [placeholder]="label() ?? ''"
      type="text"
      class="border-input rounded-input peer p-input focus:border-input-focus text-standard-text w-full cursor-pointer bg-transparent placeholder-transparent focus:ring-0"
      [ngClass]="{
        'bg-input-background h-10 rounded-md border text-base font-medium':
          appearance() === 'compact',
        'border-input-error': hasError,
        'border-standard-outline-light':
          !hasError && appearance() === 'compact',
        'border-input-ring': !hasError && appearance() === 'default',
        'pointer-events-none': ngControl.disabled || isLoading(),
      }" />
    <span
      [attr.data-testid]="id() | appendTestId: 'value'"
      class="pointer-events-none absolute flex items-center truncate bg-inherit"
      [ngClass]="{
        'top-3.5 right-6 bottom-3.5 left-4': appearance() === 'default',
        'top-1/2 right-9 left-3 -translate-y-1/2': appearance() === 'compact',
      }">
      @if (selectedOptionIcon()) {
        <span
          class="material-symbols-rounded mr-2 text-xl"
          aria-hidden="true"
          >{{ selectedOptionIcon() }}</span
        >
      }
      <span class="truncate">
        {{
          name()
            ? (ngControl.value
              | SelectionOptionValueToName
                : options()
                : name()!
                : valueAttribute())
            : ngControl.value
              ? ngControl.value
              : ''
        }}
      </span>
    </span>
    @if (appearance() === 'default') {
      <label
        [attr.data-testid]="id() | appendTestId: 'label'"
        class="peer-placeholder-shown:text-input-text peer-focus:text-input-focus pointer-events-none absolute -top-2 right-4 left-4 w-fit max-w-[calc(100%-2rem)] cursor-text overflow-hidden bg-inherit text-sm overflow-ellipsis whitespace-nowrap transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
        [for]="id()"
        [ngClass]="{
          'text-input-error': hasError,
          'text-standard-text': !hasError,
        }">
        {{ formattedLabel() }}
      </label>
    }
    @if (
      !ngControl.control!.disabled &&
      ngControl.control!.value &&
      showResetIcon() &&
      !isLoading()
    ) {
      <span
        tabIndex="0"
        (keydown.enter)="
          searchControl.setValue(''); ngControl.control!.setValue('')
        "
        (click)="searchControl.setValue(''); ngControl.control!.setValue('')"
        [id]="id() | appendTestId: 'reset'"
        [attr.data-testid]="id() | appendTestId: 'reset'"
        class="material-symbols-rounded text-input-label bg-input-background absolute top-3 right-10 bottom-3 z-10 cursor-pointer text-2xl">
        close
      </span>
    }
    @if (!ngControl.control!.disabled && !isLoading()) {
      <span
        [id]="id() | appendTestId: 'arrow-down'"
        [attr.data-testid]="id() | appendTestId: 'arrow-down'"
        class="material-symbols-rounded text-input-label bg-input-background pointer-events-none absolute flex items-center"
        [ngClass]="{
          'top-3 right-4 bottom-3 h-8 text-2xl': appearance() === 'default',
          'top-1/2 right-3 -translate-y-1/2 text-[20px]':
            appearance() === 'compact',
        }">
        {{ showList() ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </span>
    }
    @if (isLoading()) {
      <span
        class="material-symbols-rounded pointer-events-none absolute top-3 right-4 bottom-3 animate-spin text-2xl"
        >progress_activity</span
      >
    }
    <ul
      tabindex="-1"
      [attr.data-testid]="id() | appendTestId: 'options'"
      awPopupPosition
      [anchor]="id() | appendTestId: 'anchor'"
      [isVisible]="showList()"
      [ngClass]="{
        hidden: !showList(),
      }"
      class="focus:border-input-focus border-input-ring border-input rounded-input bg-input-background text-standard-text fixed z-10 -mt-px max-h-[300px] w-full overflow-y-auto focus:outline-hidden">
      @if (searchable()) {
        <li class="sticky top-0 z-10 flex items-center bg-inherit px-3 py-2">
          <div class="relative min-w-0 flex-1">
            <span
              class="material-symbols-rounded text-input-label pointer-events-none absolute top-1/2 left-3 -translate-y-1/2"
              aria-hidden="true">
              search
            </span>
            <input
              [attr.data-bwignore]="ignoreBitwardenAutofill ? 'true' : null"
              type="search"
              autocomplete="off"
              [formControl]="searchControl"
              [attr.data-testid]="id() | appendTestId: 'search'"
              [placeholder]="searchPlaceholder()"
              class="focus:border-input-focus border-input-ring border-input rounded-input h-10 w-full bg-transparent pr-3 pl-10 focus:outline-none" />
          </div>
        </li>
      }

      @if (showClearOption() && options().length > 0) {
        <li
          [attr.data-testid]="id() | appendTestId: 'clear-option'"
          (click)="clearSelection()"
          [class.rounded-t-input]="!searchable()"
          class="p-drop-down-list-item hover:bg-primary-main/13 min-h-[2.5rem] w-full cursor-pointer">
          {{ clearOptionLabel() }}
        </li>
      }

      @for (option of filteredOptions(); track $index; let index = $index) {
        <li
          [attr.data-testid]="id() + index | appendTestId: 'option'"
          (click)="selectOptionAndSetItem(option, index)"
          [class.rounded-t-input]="!showClearOption() && index === 0"
          [class.rounded-b-input]="index === filteredOptions().length - 1"
          class="p-drop-down-list-item data-[selected=true]:bg-primary-main data-[selected=true]:text-primary-on data-[selected=false]:hover:bg-primary-main/13 min-h-[2.5rem] w-full cursor-pointer"
          [attr.data-selected]="selectedItem() === $index">
          @let iconRaw =
            option && typeof option === 'object'
              ? (option | toSelectOptionAttribute: 'icon')
              : undefined;
          @let icon = typeof iconRaw === 'string' ? iconRaw : null;
          <div class="flex items-center">
            @if (icon) {
              <span
                class="material-symbols-rounded mr-2 text-xl"
                aria-hidden="true"
                >{{ icon }}</span
              >
            }
            <span>{{ option | toSelectOptionAttribute: name() }}</span>
          </div>
        </li>
      }

      @if (filteredOptions().length === 0) {
        <li class="px-3 py-2">
          {{
            textStore.texts()
              | filterTexts: ERelationType.noOptions : EEntityType.generic
              | language
          }}
        </li>
      }
    </ul>
  </div>
  @if (hasError && !errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-content></ng-content>
    </aw-error-message>
  }
  @if (hasError && errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
    </aw-error-message>
  }
</div>
